import { __read, __spreadArray } from "tslib";
import { merge } from 'rxjs';
var subscribeToPublicApiEvents = function (dispatchEvent) {
    var events = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        events[_i - 1] = arguments[_i];
    }
    return merge.apply(void 0, __spreadArray([], __read(events), false)).subscribe(function (event) { return dispatchEvent(event); });
};
export { subscribeToPublicApiEvents };
//# sourceMappingURL=subscribeToPublicApiEvents.js.map